import LoggerWrapper from './LoggerWrapper';
let logger;
export default (options => {
  if (!logger) {
    logger = new LoggerWrapper(options);
  }
  return logger;
});